import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  ActivityStatus,
  OptionalCompleteActivity
} from 'src/app/models/activities';
import { WorkflowService } from 'src/app/services';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';

@Component({
  selector: 'app-optional-complete-activity-input',
  templateUrl: './optional-complete-activity-input.component.html',
  styleUrl: './optional-complete-activity-input.component.css',
  standalone: false
})
export class OptionalCompleteActivityInputComponent extends ActivityView
  implements OnInit {
  activity: OptionalCompleteActivity;
  canBegin: boolean;
  canCancel: boolean;

  constructor(
    @Inject(forwardRef(() => WorkflowService))
    private _workflowSvc: WorkflowService,
    private _toastrSvc: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    this.canBegin = this.activity.status == ActivityStatus.InProgress;
    this.canCancel = this.activity.status == ActivityStatus.Completed;
  }

  beginOptionalRoute() {
    this.goNext.emit(true);
  }

  cancelOptionalRoute() {
    this._workflowSvc
      .undoOptionalCompleteActivity(
        this.applicationId,
        this.activity.activityDataId
      )
      .subscribe(success => {
        if (success) {
          this.onRefreshApp.emit();
        } else {
          this._toastrSvc.error(
            'Unable to cancel the activities that follow.  If this problem continues, please contact support.',
            null,
            { disableTimeOut: true }
          );
        }
      });
  }
}
